import { StyleSheet, View } from 'react-native';

import { MenuAcceleratorBadgeSvg } from './menu-accelerator-badge';

interface IMenuAcceleratorBadge {
  position?: 'absolute' | '';
}

export const MenuAcceleratorBadge = ({ position = '' }: IMenuAcceleratorBadge) => {
  return (
    <View style={[styles.container, position === 'absolute' ? { position } : { left: 10 }]}>
      <MenuAcceleratorBadgeSvg />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    top: 0,
    right: 0,
    zIndex: 9999,
    height: 24,
    width: 24,
  },
});
